<template>
  <div class="east-search">
    <div class="east-search__top">
      <div class="top__title">
        <div class="top__title__left">
          <slot name="top-title-left"></slot>
        </div>
        <div class="top__title__center">
          <span class="span-ellipsis">
            <slot name="top-title-center"></slot>
          </span>
        </div>
        <div class="top__title__right">
          <slot name="top-title-right"></slot>
        </div>
      </div>
      <div class="top__filters">
        <east-search-filter
          :filters="list.meta.filters"
          @search="handleSearch"
          @filterByOrigin="handleFilterByOrigin">
        </east-search-filter>
      </div>
    </div>
    <div class="east-search__central">
      <nuttrema-loader v-if="list.fetching"></nuttrema-loader>

      <nuttrema-empty-result
        v-else-if="notFound"
        class="with-logo in-east-block"
        icon="far fa-search">
        <template slot="text">
          <h1 v-html="$t('label.result_is_empty')"></h1>
          <h4 v-html="$t('label.redefine_search')"></h4>
        </template>
      </nuttrema-empty-result>

      <nuttrema-empty-result
        v-else-if="totalResults === 0"
        class="with-logo in-east-block"
        icon="far fa-battery-slash">
        <template slot="text">
          <h1 v-html="$t('label.list_is_empty')"></h1>
        </template>
      </nuttrema-empty-result>

      <template v-else>
        <template v-for="group in list.data" v-if="group.items.length > 0">
          <east-search-item-group :group="group" @itemClick="handleItemClick"></east-search-item-group>
        </template>
      </template>
    </div>
    <div class="east-search__bottom" v-if="totalPages > 1 || showBottom">
      <slot name="bottom" v-if="showBottom"></slot>

      <div class="bottom__center" v-if="totalPages > 1">
        <el-pagination
           small
           layout="prev, pager, next"
          :page-size="100"
          :total="totalResults"
          @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash';

import NuttremaLoader from 'components/ui/panels/nuttrema-loader';
import NuttremaEmptyResult from 'components/ui/panels/nuttrema-empty-result';

import EastSearchFilter from './east-search-filter';
import EastSearchItemGroup from './east-search-item-group';

export default {
  name: 'east-search',
  props: {
    list: {
      required: true,
      default: null,
    },
    showBottom: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    NuttremaLoader,
    NuttremaEmptyResult,
    EastSearchFilter,
    EastSearchItemGroup,
  },
  data() {
    return {
      search: '',
      filters: '',
    };
  },
  computed: {
    totalPages() {
      return get(this.list, 'meta.pagination.total_pages', 0);
    },
    totalResults() {
      return get(this.list, 'meta.pagination.total_including_special', 0);
    },
    notFound() {
      const totalResults = get(this.list, 'meta.pagination.total_including_special', 0) || 0;
      return totalResults === 0 && (this.search !== '' || this.filters !== '');
    },
  },
  methods: {
    handlePageChange(page) {
      this.$emit('pageChange', page);
    },
    handleItemClick(params) {
      this.$emit('itemClick', params);
    },
    handleSearch(value) {
      this.search = value;
      this.$emit('search', value);
    },
    handleFilterByOrigin(value) {
      this.filters = value;
      this.$emit('filterByOrigin', value);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~assets/styles/theme/colors';

  .span-ellipsis {
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
    top: 0; left: 0; bottom: 0; right: 0;
  }

  .east-search {
    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    justify-content: space-between;
  }

  .east-search__top {
    display: flex;
    flex-shrink: 0;
    align-self: stretch;
    flex-direction: column;

    .top__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 3.25rem;
      border-bottom: 2px solid #DBE2EF;
      padding: 0 0.75em;
    }

    .top__title__left, .top__title__right {
      display: flex;
      min-width: 3em;
      a {
        color: gray;
      }
    }

    .top__title__right {
      justify-content: flex-end;
      align-items: center;
    }

    .top__title__center {
      flex-grow: 1;
      display: flex;
      position: relative;
      align-self: stretch;
      justify-content: center;
      > span {
        font-weight: 600;
        line-height: 3rem;
        text-align: center;
      }
    }
  }

  .east-search__central {
    flex-grow: 1;
    display: flex;
    overflow-y: auto;
    position: relative;
    align-self: stretch;
    flex-direction: column;
    background-color: rgba(#DBE2EF, 0.25);
  }


  .east-search__bottom {
    display: flex;
    flex-shrink: 0;
    min-height: 3rem;
    padding: 0 0.75em;
    align-self: stretch;
    justify-content: center;
    align-items: center;
    border-top: 2px solid #DBE2EF;

    .bottom__row {
      display: flex;
      flex-shrink: 0;
      flex-grow: 1;
      a {
        width: 100%;
      }
    }

    .bottom__center {
      display: flex;
      flex-shrink: 0;
      /deep/ .el-pagination {
        .el-pager {
          > li {
            color: rgba(#607d8b, 0.65);
            &:hover, &:focus, &:active {
              color: rgba(#607d8b, 0.85);
            }
            &.active {
              color: #409EFF;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/search/east-search.vue